module.exports = __webpack_public_path__ + "static/media/icon_status.4f4c90e5.svg";